import { motion } from 'framer-motion';

const VINYL =
  'https://customer-assets.emergentagent.com/job_dj-alfredj/artifacts/znwitu10_alfredj2.webp';

const STATS = [
  { num: '30', label: 'Años en cabina' },
  { num: '+800', label: 'Eventos pinchados' },
  { num: '100%', label: 'Selección propia' },
];

const fade = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

export const ValueProp = () => (
  <section id="sobre" data-testid="value-section" className="relative py-20 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
      <motion.div
        variants={fade}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: '-100px' }}
        className="lg:col-span-7"
      >
        <p className="text-acid uppercase tracking-[0.3em] text-xs mb-5">¿Por qué Alfredj?</p>
        <h2 className="font-heading uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight text-[#f1f0ea]">
          No soy un DJ de <span className="text-stroke-acid">grandes éxitos</span>. Soy un selector musical.
        </h2>
        <p className="mt-7 text-base sm:text-lg text-[#f1f0ea]/75 font-light max-w-2xl">
          Tres décadas leyendo pistas y construyendo atmósferas. Cojo lo mejor del indie-rock,
          indie-pop, britpop y los clásicos alternativos y lo adapto en directo a la energía de la
          sala. Cada sesión es una historia con principio, tensión y clímax, nunca una playlist al azar.
        </p>
        <p className="mt-4 text-base sm:text-lg text-[#f1f0ea]/75 font-light max-w-2xl">
          Si buscas una noche que suene a ti y no a la radio comercial, estás en el sitio correcto.
        </p>

        <div className="mt-12 grid grid-cols-3 gap-6 border-t border-white/10 pt-8">
          {STATS.map((s) => (
            <div key={s.label} data-testid={`stat-${s.num}`}>
              <div className="font-heading text-4xl sm:text-6xl text-acid leading-none">{s.num}</div>
              <div className="mt-2 text-xs sm:text-sm uppercase tracking-wider text-[#f1f0ea]/60">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </motion.div>

      <motion.div
        variants={fade}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: '-100px' }}
        className="lg:col-span-5 relative"
      >
        <div className="relative border border-white/10 overflow-hidden">
          <img
            src={VINYL}
            alt="Vinilo girando en el plato"
            loading="lazy"
            className="w-full h-[420px] sm:h-[520px] object-cover saturate-[0.8]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-ink/70 to-transparent" />
          <div className="absolute bottom-5 left-5 font-heading uppercase text-2xl text-[#f1f0ea]">
            30 años <span className="text-acid">en cabina</span>
          </div>
        </div>
      </motion.div>
    </div>
  </section>
);
